import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { useUser } from "contexts/v1/masterData/UserContext";
import { useWarehouse } from "../context/WarehouseContext";

const ServiceBasicInfo = ({ formData, setFormData }) => {
  const { users } = useUser();
  const { warehouses } = useWarehouse();

  return (
    <>
      <Row className="g-2 mb-2 align-items-start">
        <Col lg={6}>
          <Form.Group>
            <Form.Label className="mb-1">Pilih Mekanik</Form.Label>
            <AsyncSelect
              loadOptions={(inputValue) => {
                const filtered =
                  users.data
                    ?.filter(
                      (user) =>
                        user.roles.some((role) => role.name === "mekanik") &&
                        user.name
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                    )
                    .map((user) => ({
                      value: user.id,
                      label: user.name,
                    })) || [];
                return Promise.resolve(filtered);
              }}
              value={
                formData.mechanic_id
                  ? {
                      value: formData.mechanic_id,
                      label:
                        users.data?.find(
                          (user) => user.id === formData.mechanic_id
                        )?.name || "",
                    }
                  : null
              }
              onChange={(selected) =>
                (function (selected) {
                  const mechanicId = selected ? selected.value : "";
                  // Always set warehouse to "BMK" (Bengkel Mekanik)
                  const bmkWarehouse = warehouses?.find(
                    (w) => w.code === "BMK"
                  );
                  const warehouseId = bmkWarehouse?.id || "";
                  setFormData((prev) => ({
                    ...prev,
                    mechanic_id: mechanicId,
                    warehouse_id: warehouseId,
                  }));
                })(selected)
              }
              isSearchable
              placeholder="Cari dan pilih mekanik..."
              isClearable
              defaultOptions={
                users.data
                  ?.filter((user) =>
                    user.roles.some((role) => role.name === "mekanik")
                  )
                  .map((user) => ({
                    value: user.id,
                    label: user.name,
                  })) || []
              }
              cacheOptions={false}
              className="form-control"
              classNamePrefix="react-select"
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 34,
                  borderColor: "#d9e2ef",
                }),
                valueContainer: (base) => ({
                  ...base,
                  paddingTop: 0,
                  paddingBottom: 0,
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: 32,
                }),
              }}
            />
          </Form.Group>
        </Col>
        {/* hidden warehouse input - will be set automatically from selected mechanic */}
        <Form.Control type="hidden" value={formData.warehouse_id || ""} />
        <Col lg={6}>
          <Form.Group>
            <Form.Label className="mb-1">Deskripsi Service</Form.Label>
            <Form.Control
              as="textarea"
              rows={1}
              value={formData.description}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              placeholder="Masukkan deskripsi service..."
              required
              style={{ minHeight: 34 }}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="g-2 mb-3 align-items-end">
        <Col sm={6} md={3}>
          <Form.Group>
            <Form.Label className="mb-1 small text-muted">Tanggal Service</Form.Label>
            <Form.Control
              size="sm"
              type="date"
              value={formData.service_date}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  service_date: e.target.value,
                }))
              }
              required
            />
          </Form.Group>
        </Col>
        <Col sm={6} md={3}>
          <Form.Group>
            <Form.Label className="mb-1 small text-muted">Next Service</Form.Label>
            <Form.Control
              size="sm"
              type="date"
              value={formData.next_service}
              readOnly
              style={{ backgroundColor: "#f8f9fa", cursor: "not-allowed" }}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <div className="small text-muted pb-1">
            Next service otomatis 2 bulan dari tanggal service.
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ServiceBasicInfo;
